import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "svg-icon svg-icon-3" }
const _hoisted_7 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("merchants.contacts")), 1)
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
      _createVNode(_component_el_table, {
        data: _ctx.salesChannelsTableData,
        style: {"width":"100%"},
        size: "small"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('merchants.id'),
            prop: "id",
            width: "60px"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('merchants.position'),
            prop: "__show.position"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('merchants.salutation'),
            width: "100"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.salutation == 0 || row.salutation == 1
                ? row.salutation == 0
                  ? "Male"
                  : "Female"
                : row.salutation), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('merchants.firstName'),
            prop: "firstname"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('merchants.lastName'),
            prop: "lastname"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('merchants.merchantCompany'),
            prop: "__show.merchant_id"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('merchants.phone'),
            prop: "phone"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: "",
            width: "100",
            align: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_router_link, {
                to: {
                name: 'contacts-information',
                params: {
                  id: row.id,
                },
              },
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                title: "Edit"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary align-self-center me-2",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
      }, [
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("common.backToList")), 1)
      ])
    ])
  ]))
}